import React, { useEffect, useState } from "react";
import animationStyles from "@/styles/animation.module.css";
import useDimensions from "react-cool-dimensions";
import { ResizeObserver } from "@juggle/resize-observer";
import classNames from "classnames";
import PropTypes from "prop-types";

const SlideAnimationFrame = (props) => {
  const {
    sections,
    activeSectionIndex,
    instanceId,
    className,
    noAnimatedContainer,
    watchValue,
  } = props;
  const parentRef = React.createRef();

  const [current, setCurrent] = useState(activeSectionIndex);
  const [prev, setPrev] = useState(current);
  const [next, setNext] = useState(current);

  const updateActiveFrameDimensions = (ref) => {
    ref.style.height =
      document.querySelector(`.${instanceId} .${sections[current].id}`)
        ?.scrollHeight + "px";
  };

  const { observe } = useDimensions({
    useBorderBoxSize: true,
    polyfill: ResizeObserver,
    onResize: ({ entry }) => {
      //console.log(entry);
      updateActiveFrameDimensions(entry.target);
    },
  });

  useEffect(() => {
    updateActiveFrameDimensions(parentRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current, , watchValue]);

  useEffect(() => {
    setPrev(current);
    setNext(activeSectionIndex);
    setTimeout(() => {
      setCurrent(activeSectionIndex);
    }, 10);
  }, [activeSectionIndex]);

  const getClassName = (index) => {
    if (current === index) {
      return classNames(
        animationStyles.animationFrameContent,
        prev === index && animationStyles.animationFrameContentWithTransition,
        next === index && animationStyles.animationFrameContentWithTransition,
        sections[index].id
      );
    } else {
      if (current > index) {
        return classNames(
          animationStyles.animationFrameContent,
          prev === index && animationStyles.animationFrameContentWithTransition,
          next === index && animationStyles.animationFrameContentWithTransition,
          animationStyles.animationFrameContentLeft,
          sections[index].id
        );
      } else {
        return classNames(
          animationStyles.animationFrameContent,
          prev === index && animationStyles.animationFrameContentWithTransition,
          next === index && animationStyles.animationFrameContentWithTransition,
          animationStyles.animationFrameContentRight,
          sections[index].id
        );
      }
    }
  };

  return (
    <div
      className={classNames(
        instanceId,
        animationStyles.animationContainer,
        noAnimatedContainer === true && animationStyles.animationContainerWT,
        className !== undefined && className
      )}
      ref={(el) => {
        observe(el);
        parentRef.current = el;
      }}
    >
      {sections?.map((section, index) => (
        <div
          className={getClassName(index)}
          key={`${instanceId}_animation_frame_${index}`}
        >
          {section.children}
        </div>
      ))}
    </div>
  );
};

SlideAnimationFrame.propTypes = {
  sections: PropTypes.array,
  activeSectionIndex: PropTypes.number,
  instanceId: PropTypes.string,
  className: PropTypes.string,
  noAnimatedContainer: PropTypes.bool,
  watchValue: PropTypes.any,
};

export default SlideAnimationFrame;
